<template>
    <el-cascader @change="change"
                 v-model="vModel"
                 :remote="remote"
                 :options="options"
                 :change-on-select="changeonselect"
                 :show-all-levels="showalllevels"
                 :placeholder="placeholder"
                 :clearable="true"
    ></el-cascader>
</template>

<script>
    import util from '../common/util'
    export default {
        props:{
            disabled:{
                type:Boolean,
                default:false
            },
            remote:{
                type:Boolean,
                default:false
            },
            changeonselect:{
                type:Boolean,
                default:true
            },
            showalllevels:{
                type:Boolean,
                default:false
            },
            optionsData:null,
            value:null,
            placeholder:{
                type:String,
                default:"请选择"
            },
        },
        data() {
            return {
                vModel:this.value,
                options:[],
                valueKey:'value'
            };
        },
        watch:{
            value(val){
                this.vModel = val
            },
            vModel(val){
                this.$emit("input", val)
            },
             //动态可以改变数据
            optionsData(val){
                //初始化之前，watch是不会触发的
                //this.vModel = null;  //为什么？  因为切换记录时？
                this.fillData(val)
            }
        },
        methods:{
              change(val){
                 //查找 record
                    let record =null;
                    if(val.length==1){
                    for(let item of this.options){
                        if(item[this.valueKey]==val){
                            record = item
                            break
                        }
                    }
                    }
                    if(val.length==2){
                      for(let item of this.options){
                        if(item.children){
                        for(let childitem of item.children){
                           if(childitem[this.valueKey]==val[1]){
                                record = childitem
                                break
                           }
                       }
                       if(record!=null){
                           break
                       }
                        }
                    }
                    }
                 this.$emit("change", val,record)
            },
             fillData(val,callback){
                if(!val){
                    return
                }
                if(typeof(val)=="string"){
                    //url模式, 带{0}表示远程搜索,初始值要为空值
                    
                    util.get(val, {}, null, result => {
                        this.options = result.data
                        if(callback){
                            callback()
                        }
                    })
                }
             }
        },
        mounted() {
            if(this.remote){

            }else {
                if(typeof(this.optionsData)=="string"){
                    //url模式, 带{0}表示远程搜索,初始值要为空值
                    util.get(this.optionsData, {}, null, result => {
                        this.options = result.data
                    })
            }
                else{
                    this.options = this.optionsData
                }
            }

        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Cascader.vue